import { gql } from '@edreamsodigeo/frontend-api-client';
import { itinerarySearchItinerary } from './itinerarySearchItinerary';

export const ITINERARY_SEARCH_ALTERNATIVES = gql`
  mutation ItinerarySearchAlternatives(
    $itinerarySearchAlternativesRequest: ItinerarySearchAlternativesRequest!
  ) {
    itinerarySearchAlternatives(
      itinerarySearchAlternativesRequest: $itinerarySearchAlternativesRequest
    ) {
      searchId
      itineraries {
        ...ItinerarySearchItineraryFragment
      }
      carbonFootprints {
        id
        carbonFootprint {
          isEco
          ecoPercentageThanAverage
          totalCo2Kilos
          totalCo2eKilos
        }
      }
      carriers {
        id
        carrier {
          id
          name
          supportUrl
        }
      }
      locations {
        id
        location {
          id
          iata
          cityIata
          cityName
          name
          countryName
          locationType
        }
      }
    }
  }
  ${itinerarySearchItinerary}
`;
